/* istanbul ignore file */
import React from 'react';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';
import { LinkButton } from 'framework/ui/ui-builder';

const ViewInvoiceButton = (props: any) => {
  const { getSingleEntityUrl } = useInvoiceUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-journal-entry" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewInvoiceButton;
